<template>
  <div class="quoted-shipments">
    <template v-if="shipments.length > 1">
      <div class="well">
        <a
          :href="splitShipmentArticleLink"
          class="split-shipment-article-link"
        >
          <img
            :src="SplitShipmentIcon"
            alt="Split Shipment"
            class="split-shipment-icon"
          />
        </a>
        <h3>Split Shipment</h3>
        We are unable to ship this order entirely from your
        closest distribution center so a portion will
        ship from a second location.
        Below are shipping rates from each point.
        During the checkout process you'll be able
        to select delivery options for each shipment.
        <br />
        <a :href="splitShipmentArticleLink">
          Click here for more information
        </a>.
      </div>
    </template>

    <quoted-shipment
      v-for="shipment in shipments"
      :key="shipment.number"
      :number="shipment.number"
      :unshippable-by-air-variants="shipment.unshippable_by_air_variants"
      :almost-available-for-pickup-message="shipment.almost_available_for_pickup_message"
      :almost-available-for-shipping-discount="shipment.almost_available_for_shipping_discount"
      :messages="shipment.messages"
      :shipping-origin="shipment.shipping_origin"
      :shipping-rates="shipment.shipping_rates"
    />
  </div>
</template>

<script>
  import SplitShipmentIcon from 'images/logos/split-shipment-icon.gif';
  import QuotedShipment from './quoted-shipment'

  export default {
    components: {
      QuotedShipment
    },
    props: {
      splitShipmentArticleLink: {
        type: String,
        required: true
      },
      shipments: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        SplitShipmentIcon
      };
    }
  };
</script>
